<template>
    <div class="possible-efforts-sub-menu">
        <div class="switcher">
            <div class="item" :class="{'selected': selectedItem === 'moreTime'}" @click="selectedItem = 'moreTime'">
                <span>{{ texts.moreTime.boksTekst }}</span>
                <!--<i class="far fa-fw fa-arrow-down" v-if="selectedItem === 'moreTime'"></i>
                <i class="far fa-fw fa-arrow-right" v-else></i>-->
            </div>
            <div class="item" :class="{'selected': selectedItem === 'lessSickness'}" @click="selectedItem = 'lessSickness'">
                <span>{{ texts.lessSickness.boksTekst }}</span>
                <!--<i class="far fa-fw fa-arrow-down" v-if="selectedItem === 'lessSickness'"></i>
                <i class="far fa-fw fa-arrow-right" v-else></i>-->
            </div>
            <div class="item" :class="{'selected': selectedItem === 'rightPeople'}" @click="selectedItem = 'rightPeople'">
                <span>{{ texts.rightPeople.boksTekst }}</span>
                <!--<i class="far fa-fw fa-arrow-down" v-if="selectedItem === 'rightPeople'"></i>
                <i class="far fa-fw fa-arrow-right" v-else></i>-->
            </div>
        </div>
        <div v-show="selectedItem === 'moreTime'">
            <div class="" style="margin-top:40px;">
                <div class="" style="margin-bottom:30px;">
                    <div class="lg" style="margin-top:0px;">
                        {{ texts.moreTime.tykTekst1 }}
                        {{ data.more_time.percentage_with_customers | number }}%
                        <br><br>
                        {{ texts.moreTime.tykTekst2 }}
                        {{ data.more_time.possible_revenue_increase | currency }}
                    </div>
                    <div class="sub" v-html="texts.moreTime.tyndTekst1">
                        {{ texts.moreTime.tyndTekst1 }}
                    </div>
                </div>
                <div class="">
                    <div class="g-table-wrapper">
                        <div class="placeholder">
                            <div class="placeholder__heading">
                                Hvad bruger vi tiden på i dag?
                            </div>
                            <div class="placeholder">

                                <vue-good-table
                                    :columns="moreTimeColumns"
                                    :rows="data.more_time.table"
                                    :search-options="searchOptions"
                                    :pagination-options="paginationOptions"
                                    :sort-options="sortOptions"
                                    :styleClass="styleClass"
                                >
                                    <div slot="emptystate">
                                        Ingen data ...
                                    </div>
                                    <template slot="table-row" slot-scope="props">
                                        <div v-if="props.column.field == 'type'" style="text-align:left;">
                                            {{ props.row.type }}
                                        </div>
                                        <div v-else-if="props.column.field == 'percentage'" style="text-align:left;">
                                            {{ props.row.percentage | number }}%
                                        </div>
                                        <div v-else-if="props.column.field == 'hours'" style="text-align:left;">
                                            {{ props.row.hours | number }}
                                        </div>
                                        <div v-else :title="props.formattedRow[props.column.field]">
                                            {{ props.formattedRow[props.column.field] }}
                                        </div>
                                    </template>
                                </vue-good-table>

                            </div>
                        </div>
                    </div>
                    <div class="foot right">
                        <div class="button" @click="goToRoute('EmployeesLearning', 'timeUsage')">
                            Gå til "Hvad bruger vi tiden på?" &rarr;
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-show="selectedItem === 'lessSickness'">
            <div class="" style="margin-top:40px;">
                <div class="" style="margin-bottom:30px;">
                    <div class="lg" style="margin-top:0px;">
                        {{ texts.lessSickness.tykTekst1 }}
                        {{ data.less_sickness.percentage | number }}%
                        <br><br>
                        {{ texts.lessSickness.tykTekst2 }}
                        {{ data.less_sickness.possible_revenue_increase | currency }}
                    </div>
                    <div class="sub" v-html="texts.lessSickness.tyndTekst1">
                        {{ texts.lessSickness.tyndTekst1 }}
                    </div>
                </div>
                <div class="">
                    <div class="g-table-wrapper">
                        <div class="placeholder">
                            <div class="placeholder__heading">
                                Medarbejdernes sygefravær
                            </div>
                            <div class="placeholder">

                                <vue-good-table
                                    :columns="employeesSicknessRateColumns"
                                    :rows="data.employees_sickness_rate"
                                    :search-options="searchOptions"
                                    :pagination-options="paginationOptions"
                                    :sort-options="employeesSicknessRateSortOptions"
                                    :styleClass="styleClass"
                                >
                                    <div slot="emptystate">
                                        Ingen data ...
                                    </div>
                                    <template slot="table-row" slot-scope="props">
                                        <div v-if="props.column.field == 'name'" style="text-align:left;">
                                            {{ props.row.name }}
                                        </div>
                                        <div v-else-if="props.column.field == 'sickness_percentage'" style="text-align:left;">
                                            {{ props.row.sickness_percentage | number }}%
                                        </div>
                                        <div v-else-if="props.column.field == 'sickness_hours'" style="text-align:left;">
                                            {{ props.row.sickness_hours | number }}
                                        </div>
                                        <div v-else :title="props.formattedRow[props.column.field]">
                                            {{ props.formattedRow[props.column.field] }}
                                        </div>
                                    </template>
                                </vue-good-table>

                            </div>
                        </div>
                    </div>
                    <div class="foot right">
                        <div class="button" @click="goToRoute('EmployeesLearning', 'timeUsage')">
                            Gå til "Hvad bruger vi tiden på?" &rarr;
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-show="selectedItem === 'rightPeople'">
            <div class="lg">
                {{ texts.rightPeople.tykTekst1 }}
                {{ employeesRightPeoplePossibleRevenue | currency }}
            </div>
            <div class="sub">
                <div v-html="texts.rightPeople.tyndTekst1">
                    {{ texts.rightPeople.tyndTekst1 }}
                </div>
                <br>
                <table>
                    <tbody>
                        <!--<tr>
                            <td style="padding-right:15px;">Den opgavetype, I bruger mest tid på, er:</td>
                            <td>{{ projects.right_projects.table[0].name }}</td>
                        </tr>
                        <tr>
                            <td style="padding-right:15px;"> Antal timer der bruges på opgavetypen:</td>
                            <td>{{ projects.right_projects.table[0].timelog_hours_total | number }} timer.</td>
                        </tr>
                        <tr>
                            <td style="padding-right:15px;">Gennemsnitligt dækningsbidrag pr. time</td>
                            <td>{{ projects.right_projects.table[0].coverage_per_hour | currency }}</td>
                        </tr>-->
                        <tr>
                            <td style="padding-right:15px;">Antal timer brugt på alle kundeopgaver i perioden</td>
                            <td>{{ data.right_people.total_coverage / data.right_people.avg_coverage_per_hour | number }}</td>
                        </tr>
                        <tr>
                            <td style="padding-right:15px;">Gennemsnitligt dækningsbidrag pr. time</td>
                            <td>{{ data.right_people.avg_coverage_per_hour | currency }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="g-table-wrapper">
                <div class="placeholder">
                    <div class="placeholder__heading">
                        <d-tooltip placement="left" identifier="employees.employeeRevenue" />
                        Hvordan er medarbejdernes indtjening?
                    </div>
                    <div class="placeholder">

                        <vue-good-table
                            :columns="rightPeopleColumns"
                            :rows="data.right_people.table"
                            :search-options="searchOptions"
                            :pagination-options="paginationOptions"
                            :sort-options="rightPeopleSortOptions"
                            :styleClass="styleClass"
                        >
                            <div slot="emptystate">
                                Ingen data ...
                            </div>
                            <template slot="table-row" slot-scope="props">
                                <div class="coverage-cell" v-if="props.column.field == 'coverage_percent'" >
                                    {{ props.row.coverage_percent | coveragePercent }} 
                                    <div
                                        v-if="props.row.coverage_percent !== null"
                                        class="coverage-indicator"
                                        :class="{'bad': props.row.coverage_percent < $store.state.config.companyMeta.settings.coverage_percent.medium.value, 'avg': $options.filters.rounded(props.row.coverage_percent) >= $store.state.config.companyMeta.settings.coverage_percent.medium.value, 'good': $options.filters.rounded(props.row.coverage_percent) >= $store.state.config.companyMeta.settings.coverage_percent.high.value}"
                                    />
                                </div>
                                <div v-else-if="props.column.field == 'total_projects'" style="text-align:left;">
                                    {{ props.row.total_projects }}
                                </div>
                                <div v-else-if="props.column.field == 'name'" class="table-column__description">
                                    {{ props.row.name }}
                                </div>
                                <div v-else-if="props.column.field == 'coverage'" style="text-align:left;">
                                    {{ props.row.coverage | currency }}
                                </div>
                                <div v-else-if="props.column.field == 'invoices_total'" style="text-align:left;">
                                    {{ props.row.invoices_total | currency }}
                                </div>
                                <div class="coverage-cell" v-else-if="props.column.field == 'coverage_per_hour'">
                                    {{ props.row.coverage_per_hour | currency }} 
                                    <div
                                        v-if="props.row.coverage_per_hour !== null"
                                        class="coverage-indicator"
                                        :class="{'bad': props.row.coverage_per_hour < $store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'avg': $options.filters.rounded(props.row.coverage_per_hour) >= $store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'good': $options.filters.rounded(props.row.coverage_per_hour) >= $store.state.config.companyMeta.settings.coverage_per_hour.high.value}"
                                    />
                                </div>
                                <div v-else>
                                    {{ props.formattedRow[props.column.field] }}
                                </div>
                            </template>
                        </vue-good-table>

                    </div>
                </div>
            </div>
            <div class="foot">
                <div class="button" @click="goToRoute('ProjectsLearning', 'projectTypeSkills')">
                    Gå til "Hvilke svende er gode til hvilke opgaver?" &rarr;
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['selectedBox', 'data', 'employeesRightPeoplePossibleRevenue', 'projects', 'texts'],
    data () {
        return {
            selectedItem: 'moreTime',
            moreTimeColumns: [
                { label: 'Type', field: 'type', type: 'string' },
                { label: 'Tid (%)', field: 'percentage', type: 'number' },
                { label: 'Antal timer', field: 'hours', type: 'number' }
            ],
            employeesSicknessRateColumns: [
                { label: 'Medarbejder', field: 'name', type: 'string' },
                { label: 'Sygefravær (%)', field: 'sickness_percentage', type: 'number' },
                { label: 'Antal timer', field: 'sickness_hours', type: 'number' }
            ],
            rightPeopleColumns: [
                { label: 'Initialer', field: 'initials', type: 'string' },
                { label: 'Medarbejder', field: 'full_name', type: 'string' },
                { label: 'Antal opgaver', field: 'total_projects', type: 'number' },
                { label: 'Omsætning', field: 'invoices_total', type: 'number' },
                { label: 'DB', field: 'coverage', type: 'number' },
                { label: 'DG', field: 'coverage_percent', type: 'number' },
                { label: 'DB pr. time', field: 'coverage_per_hour', type: 'number' }
            ],
            searchOptions: {
                enabled: true,
                trigger: 'enter',
                placeholder: 'Søg og tryk enter ...',
                skipDiacritics: true
            },
            paginationOptions: {
                enabled: true,
                perPage: 10,
                rowsPerPageLabel: 'Rækker pr. side',
                allLabel: 'Alle',
                nextLabel: 'Næste',
                prevLabel: 'Forrige',
                ofLabel: 'af',
                pageLabel: 'side'
            },
            sortOptions: {
                enabled: true,
                initialSortBy: {
                    field: 'percentage',
                    type: 'desc'
                }
            },
            employeesSicknessRateSortOptions: {
                enabled: true,
                initialSortBy: {
                    field: 'sickness_percentage',
                    type: 'desc'
                }
            },
            rightPeopleSortOptions: {
                enabled: true,
                initialSortBy: {
                    field: 'coverage_per_hour',
                    type: 'desc'
                }
            },
            mostImportantSortOptions: {
                enabled: true,
                initialSortBy: {
                    field: 'coverage_total',
                    type: 'desc'
                }
            },
            styleClass: 'vgt-table'
        }
    },
    methods: {
        goToRoute (parent, child) {
            this.$router.push({
                name: parent,
                params: {
                    selectedItem: child
                },
                query: {
                    tab: child
                }
            })
        }
    },
    watch: {
        selectedBox () {
            if (this.selectedBox) {
                this.selectedItem = this.selectedBox
            } else {
                this.selectedItem = 'moreTime'
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// employees.vue?36445354